import { ReactElement } from 'react'
import { Box, Button, Column, Columns, Dialog } from '@machobear/design-system'

import { WarningIconTriangle } from '@/components/icons'

interface Button {
  text: string
  id?: string
  onClick?: () => void
}

interface Props {
  eventId?: string
  visible: boolean
  closeModal: () => void
  title: string
  description?: ReactElement
  icon?: React.ComponentType
  button: Button
  secondaryButton?: Button
}

export const WarningModal: React.FC<Props> = ({
  eventId,
  visible,
  closeModal,
  title,
  description,
  icon,
  button,
  secondaryButton
}) => {
  const IconComponent = icon ?? WarningIconTriangle

  const handleOnClick = () => {
    if (eventId) {
      window.dataLayer.push({
        event: eventId
      })
    }
    button?.onClick && button.onClick()
  }

  return (
    <Dialog
      id="unhide-listing-confirmation"
      illustration={
        <Box marginTop="gutter" marginBottom="xxsmall">
          <IconComponent width={80} height={80} />
        </Box>
      }
      title={title}
      description={description}
      open={visible}
      onClose={closeModal}
      width="xsmall"
    >
      <Columns space="gutter">
        {secondaryButton ? (
          <Column width="1/2">
            <Button variant="ghost" onClick={secondaryButton?.onClick}>
              {secondaryButton.text}
            </Button>
          </Column>
        ) : null}
        <Column>
          <Button variant="solid" onClick={handleOnClick}>
            {button.text}
          </Button>
        </Column>
      </Columns>
    </Dialog>
  )
}
